import { Fragment } from "react";
import { Icon, Table, Td, Th, Tr } from "@usas/ui-web/components/table/Table";
import { SORT_TYPES } from "@usas/ui-web/components/table/utils/TableConstants";

import useLSCRoleEmailGrid from "./UseLSCRoleEmailGrid";

const LSCRoleEmailsGrid = ({ data, isLoading, onEdit, onDelete }) => {
  const {
    gridState
  } = useLSCRoleEmailGrid(data);

  return (
    <Fragment>
      <Table.ContextWrapper data={gridState.gridData} rowIdKey={'orgUnitOrgRoleFieldId'} >
        <Table.Large>
          <thead>
            <Tr.Top colSpan={3} showDataTotal={isLoading !== true} dataName='RowField' dataTotal={data.length}>
            </Tr.Top>
            <tr>
              <Th.Sort sortKey={'orgRoleName'} sortType={SORT_TYPES.ALPHABETICAL}>Role</Th.Sort>
              <Th.Sort sortKey={'email'} sortType={SORT_TYPES.ALPHABETICAL}>Email</Th.Sort>
              <Th.Action></Th.Action>
            </tr>
          </thead>
          <Table.Body colSpan={3} isLoading={isLoading} noDataText='No LSC Staff Role Emails'
            renderRow={(rowField, i) =>
              <tr key={i}>
                <td>{rowField.orgRoleName}</td>
                <td>{rowField.email}</td>
                <Td.Action>
                  {onEdit &&
                    <Icon.Edit onClick={(e) => onEdit(e, rowField.orgUnitOrgRoleFieldId)} />
                  }
                  {onDelete &&
                    <Icon.Delete onClick={(e) => onDelete(e, rowField.orgUnitOrgRoleFieldId)} />
                  }
                </Td.Action>
              </tr>
            } />
        </Table.Large>

        <Table.Small>
          <thead>
            <Tr.Top colSpan={3} showDataTotal={isLoading !== true} dataName='RowField' dataTotal={data.length}></Tr.Top>
            <tr>
              <Th.Sort sortKey={'orgRoleName'} sortType={SORT_TYPES.ALPHABETICAL}>Role</Th.Sort>
              <Th.Sort sortKey={'email'} sortType={SORT_TYPES.ALPHABETICAL}>Email</Th.Sort>
              <Th.Action></Th.Action>
            </tr>
          </thead>
          <Table.Body colSpan={7} isLoading={isLoading} noDataText='No LSC Staff Role Emails'
            renderRow={(rowField, i) =>
              <tr key={i}>
                <td>{rowField.orgRoleName}</td>
                <td>{rowField.email}</td>
                <Td.Action>
                  {onEdit &&
                    <Icon.Edit onClick={(e) => onEdit(e, rowField.orgUnitOrgRoleFieldId)} />
                  }
                  {onDelete &&
                    <Icon.Delete onClick={(e) => onDelete(e, rowField.orgUnitOrgRoleFieldId)} />
                  }
                </Td.Action>
              </tr>
            } />
        </Table.Small>
      </Table.ContextWrapper>
    </Fragment>
  );
};

export default LSCRoleEmailsGrid;